import React from "react";

class LinkBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
    };
  }

  render() {
    if (!this.state.hidden) {
      return (
        <div className="fixedBox links">
          <i
            className="fas fa-chevron-down clickable"
            onClick={() => this.setState({ hidden: true })}
          ></i>
          <h3 className="noMargin">Useful Links:</h3>
          <a
            href="https://wiki-server/bs/index.php?title=Main_Page"
            target="_blank"
            rel="noopener noreferrer"
          >
            Wiki
          </a>{" "}
          <br />
          <a
            href="https://tuleapsv.renrns.local/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Project Management (Tuleap){" "}
          </a>
          <br />
          <a
            href="https://tuleapsv.renrns.local/plugins/tracker/?tracker=122&func=new-artifact"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Place A Support Ticket.
          </a>
          <br />
        </div>
      );
    } else {
      return (
        <div
          className="clickable panel fixedBottomRight circleIcon"
          onClick={() => this.setState({ hidden: false })}
        >
          <i className="fas fa-plus red "></i>
        </div>
      );
    }
  }
}

export default LinkBox;
